import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ThreeCalendarIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-threeCalendar"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M49,3 L18,3 C16.8957153,3 16,3.89571525 16,5 L16,32 C16,33.1042847 16.8957153,34 18,34 L49,34 C50.1042847,34 51,33.1042847 51,32 L51,5 C51,3.89571525 50.1042847,3 49,3 Z M18,5 L49,5 L49,32 L18,32 L18,5 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          points="21.5 16.5 24.5 16.5 24.5 13.5 21.5 13.5"
        />
        <path
          d="M25 13 21 13 21 17 25 17 25 13ZM24 14 24 16 22 16 22 14 24 14ZM25 19 21 19 21 23 25 23 25 19ZM24 20 24 22 22 22 22 20 24 20ZM25 25 21 25 21 29 25 29 25 25ZM24 26 24 28 22 28 22 26 24 26ZM32 13 28 13 28 17 32 17 32 13ZM31 14 31 16 29 16 29 14 31 14Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          points="28.5 22.5 31.5 22.5 31.5 19.5 28.5 19.5"
        />
        <path
          d="M32 19 28 19 28 23 32 23 32 19ZM31 20 31 22 29 22 29 20 31 20ZM32 25 28 25 28 29 32 29 32 25ZM31 26 31 28 29 28 29 26 31 26ZM39 13 35 13 35 17 39 17 39 13ZM38 14 38 16 36 16 36 14 38 14ZM39 19 35 19 35 23 39 23 39 19ZM38 20 38 22 36 22 36 20 38 20Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          points="35.5 28.5 38.5 28.5 38.5 25.5 35.5 25.5"
        />
        <path
          d="M39 25 35 25 35 29 39 29 39 25ZM38 26 38 28 36 28 36 26 38 26ZM46 13 42 13 42 17 46 17 46 13ZM45 14 45 16 43 16 43 14 45 14ZM46 19 42 19 42 23 46 23 46 19ZM45 20 45 22 43 22 43 20 45 20ZM46 25 42 25 42 29 46 29 46 25ZM45 26 45 28 43 28 43 26 45 26ZM46 0C46.5128358 0 46.9355072.38604019 46.9932723.883378875L47 1 47 3C47 3.55228475 46.5522847 4 46 4 45.4871642 4 45.0644928 3.61395981 45.0067277 3.11662113L45 3 45 1C45 .44771525 45.4477153 0 46 0ZM21 0C21.5128358 0 21.9355072.38604019 21.9932723.883378875L22 1 22 3C22 3.55228475 21.5522847 4 21 4 20.4871642 4 20.0644928 3.61395981 20.0067277 3.11662113L20 3 20 1C20 .44771525 20.4477153 0 21 0Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="18 10 49 10 49 5 18 5"
        />
      </g>
    </Icon>
  )
}
